<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"

        viewBox="0 0 24 24"
        stroke="currentColor" fill="none"
        stroke-width="2"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
        />
    </svg>
</template>

<script>
export default {
    name: "Icon_Close",
};
</script>

